(function(){
    'use strict';

    const sectionContainer = document.querySelector(".stock-lookup-section");
    const sectionId = sectionContainer.dataset.sectionId;
    const noResultMessage = sectionContainer.dataset.noResultMessage;
    const outputGridWrapper = sectionContainer.querySelector(".sl-grid-wrapper");
    const outputGridContainer = sectionContainer.querySelector('#StockLookupGrid-' + sectionId);
    const gridHeader = sectionContainer.querySelector("#StockLookupGridHeader-"+sectionId);
    const gridResultCount = sectionContainer.querySelector("#StockLookupGridCount-"+sectionId);

    const secondsGridHeader = sectionContainer.querySelector("#SecondsGridHeader-"+sectionId);
    const secondsGridCount = sectionContainer.querySelector("#SecondsGridCount-"+sectionId);
    const secondsGridContainer = sectionContainer.querySelector("#SecondsGrid-"+sectionId);

    const lengthRadios = sectionContainer.querySelectorAll("input[name='size-length']");
    const widthRadios = sectionContainer.querySelectorAll("input[name='size-width']");
    lengthRadios.forEach(lr => lr.addEventListener("change", handleLookup));
    widthRadios.forEach(wr => wr.addEventListener("change", handleLookup));

    const outputMap = new Map();
    let fetchQueue = [];
    let currentOutput = null;

    checkParams();
    bindBackButton();

    function checkParams(back) {
        const currentParams = new URLSearchParams(window.location.search);
        if(currentParams.has("length") && currentParams.has("width")) {
            const formData = new FormData();
            formData.set("length", currentParams.get("length"));
            formData.set("width", currentParams.get("width"));
            formData.set("sdcm_data", JSON.stringify(typeof sdcm_data !== "undefined" && sdcm_data ? sdcm_data : []));
            if(back) {
                const lengthRadio = document.querySelector(`input[name="size-length"][value="${currentParams.get("length")}"]`);
                const widthRadio = document.querySelector(`input[name="size-width"][value="${currentParams.get("width")}"]`);
                if(lengthRadio && widthRadio) {
                    lengthRadio.checked = true;
                    widthRadio.checked = true;                
                }
            }            
            setOutput(formData);
        }
    }

    function handleLookup() {        
        const length = sectionContainer.querySelector("input[name='size-length']:checked")?.value;
        const width = sectionContainer.querySelector("input[name='size-width']:checked")?.value;
        if(!length || !width) return;

        const formData = new FormData();
        formData.set("length", length);
        formData.set("width", width);
        formData.set("sdcm_data", JSON.stringify(typeof sdcm_data !== "undefined" && sdcm_data ? sdcm_data : []));

        const queryString = new URLSearchParams(formData);
        history.pushState({}, '', `${window.location.pathname}${queryString && '?'.concat(queryString)}`);

        setOutput(formData);
    }

    function setOutput(formData) {
        outputGridWrapper.classList.add("unload");

        const mapKey = formData.get("length") + " / " + formData.get("width");
        const output = outputMap.get(mapKey);

        fetchQueue.push(mapKey);
        if(output) {
            currentOutput = output;
            outputGridWrapper.classList.remove("unload");
            outputGridContainer.innerHTML = output.stock.markup;
            gridResultCount.innerHTML = output.stock.count;
            output.stock.count > 0 && (gridResultCount.innerText = output.stock.count + " Results");
            setSecondsOutput(output.seconds);
            if ((output.stock.refresh || output.seconds.refresh) && AOS) {
                AOS.refreshHard();
            }
            if(fetchQueue[fetchQueue.length-1] === mapKey) {
                fetchQueue = [];
            } 
        } else {
            fetch(window.Shopify.routes.root + 'apps/jkcustom/stock-lookup', {
                method: "POST",
                body: formData,
            }).then((response) => {
                if(response.status === 401) {
                    throw new Error("no session");
                }
                return response.json();
            })
            .then((body) => {
                let setContent = false;
                if(fetchQueue[fetchQueue.length-1] === mapKey) {
                    gridHeader.classList.remove("hide");
                    setContent = true;
                }
                buildGridOutput(body.data, mapKey, setContent);
            }).catch(err => {
                if(fetchQueue[fetchQueue.length-1] === mapKey) {
                    outputGridContainer.innerHTML = `<div class="enlarge-text grid__item"><p>We encountered an error looking this size, please try again.</p></div>`;
                    gridResultCount.innerHTML = "";
                }
            }).finally(() => {
                if(fetchQueue[fetchQueue.length-1] === mapKey) {
                    outputGridWrapper.classList.remove("unload");
                    fetchQueue = [];
                } 
            });
        }
    }

    function buildGridOutput(productData, key, setContent) {
        const limit = 24, 
        gridProducts = [],
        gridItemWidth = "small--one-half medium-up--one-quarter",
        rowOf = 4,
        imageSizes = "(min-width: 769px) 20vw, 39vw";

        const stockGridProducts = productData.stock.map(mapGridProduct);
        const secondsGridProducts = productData.seconds.map(mapGridProduct);

        const stockOutput = stockGridProducts.length > 0 ? { markup: theme.buildProductGridItem(stockGridProducts.slice(0, limit), gridItemWidth, rowOf, imageSizes), refresh: true, count: stockGridProducts.length+" Result" + (stockGridProducts.length === 1 ? "" : "s")} : { markup: `<div class="enlarge-text grid__item"><p>${noResultMessage}</p></div>`, refresh: false, count: "" };
        const secondsOutput = secondsGridProducts.length > 0 ? { markup: theme.buildProductGridItem(secondsGridProducts.slice(0, limit), gridItemWidth, rowOf, imageSizes), refresh: true, count: secondsGridProducts.length+" Result" + (secondsGridProducts.length === 1 ? "" : "s"), hide: false} : { markup: "", refresh: false, count: "", hide: true };        
        const output = { stock: stockOutput, seconds: secondsOutput };
        currentOutput = output;
        outputMap.set(key, output);
        if(setContent) {
            outputGridContainer.innerHTML = output.stock.markup;
            gridResultCount.innerHTML = output.stock.count;
            setSecondsOutput(output.seconds);
        }

        if ((output.stock.refresh || output.seconds.refresh) && AOS) {
            AOS.refreshHard();
        }
    }

    function mapGridProduct(data) {
        const isSeconds = Object.hasOwn(data, 'productType');
        const product = isSeconds ? data : data.product;
        const variant =  isSeconds ? data.variants.nodes[0] : data;

        const price = Shopify.currency.active === 'USD' ? variant.price : Math.ceil(variant.price * Shopify.currency.rate);
        const gridProduct = {
            id: product.id.split("/").pop(),
            handle: product.handle,
            status: product.status,
            title: product.title,
            url: isSeconds ? `https://jkbootswarehouse.com/products/${product.handle}` : `https://${window.Shopify.shop}/products/${product.handle}?variant=${variant.id.split("/").pop()}`,
            image_responsive_url: theme.Images.buildImagePath(product.featuredImage.url),
            image_responsive_urls: theme.Images.buildImagePath(product.featuredImage.url, [180, 360, 540, 720, 900]),
            image_aspect_ratio: 100,
            variant_price: theme.Currency.formatMoney(price * 100, theme.settings.moneyFormat),
            tags: isSeconds ? 'seconds' : ''
        }

        if(data.sale_data != null) {
            const saleData = getSavingsData(price, data.sale_data, isSeconds);
            gridProduct.sale_price = theme.Currency.formatMoney(saleData.sale_price * 100, theme.settings.moneyFormat);
            gridProduct.price_savings = theme.settings.saveType === 'dollar' ? theme.Currency.formatMoney(saleData.price_savings * 100, theme.settings.moneyFormat) : `${data.sale_data.savings}%`;
        } else if(isSeconds && variant.compareAtPrice) {
            const compareAtPrice = Shopify.currency.active === 'USD' ? variant.compareAtPrice : Math.ceil(variant.compareAtPrice * Shopify.currency.rate);
            const priceSavings = compareAtPrice - price;
            gridProduct.sale_price = theme.Currency.formatMoney(price * 100, theme.settings.moneyFormat);
            gridProduct.price_savings = theme.Currency.formatMoney(priceSavings * 100, theme.settings.moneyFormat);
            gridProduct.variant_price = theme.Currency.formatMoney(compareAtPrice * 100, theme.settings.moneyFormat);
        }

        return gridProduct;
    }

    function getSavingsData(price, saleData, seconds) {
        if(saleData.type === 'percentage') {      
            const savings = (100 - saleData.savings) / 100;
            const sale_price = roundMoney(price * savings);
            const price_savings = price - sale_price;
            return { sale_price, price_savings };
        } else {
            const price_savings = Shopify.currency.active === 'USD' ? saleData.savings : Math.ceil(saleData.savings * Shopify.currency.rate);
            const sale_price = price - price_savings;
            return { sale_price, price_savings };
        }
    }
    function roundMoney(num) {
        return Math.ceil(num * 100) / 100;
    }

    function setSecondsOutput(output) {
        secondsGridContainer.innerHTML = output.markup;
        secondsGridCount.innerHTML = output.count;
        if(output.hide) {
            secondsGridHeader.classList.add("hide");
        } else {
            secondsGridHeader.classList.remove("hide");
        }
    }

    function bindBackButton() {
        window.on('popstate', function(state) {
            if (state) {
                var newUrl = new URL(window.location.href);
                if(newUrl.searchParams.size > 0) {
                    checkParams(true);
                }
            }
        });
    }
})();